import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ExportCsvButton({ endpoint, filename, testId }) {
    const [busy, setBusy] = useState(false);

    async function download() {
        setBusy(true);
        try {
            const { data } = await api.get(endpoint, { responseType: "blob" });
            const url = URL.createObjectURL(new Blob([data], { type: "text/csv;charset=utf-8" }));
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            toast.success("CSV descarregado");
        } catch {
            toast.error("Erro ao exportar CSV");
        } finally {
            setBusy(false);
        }
    }

    return (
        <button onClick={download} disabled={busy} data-testid={testId}
            className="inline-flex items-center gap-2 rounded-md border border-primary px-4 py-2.5 text-sm font-bold text-primary hover:bg-primary hover:text-primary-foreground transition disabled:opacity-50">
            <Download className="h-4 w-4" /> {busy ? "A exportar..." : "Exportar CSV"}
        </button>
    );
}
